module.exports = "/account/modal-delete-org-213c53.html";